function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.25 16c-.19 0-.38-.07-.53-.22L12 13.06l-2.72 2.72c-.29.29-.77.29-1.06 0l-3.25-3.25a.754.754 0 010-1.06l3.25-3.25c.29-.29.77-.29 1.06 0L12 10.94l2.72-2.72c.29-.29.77-.29 1.06 0l3.25 3.25c.29.29.29.77 0 1.06l-3.25 3.25c-.15.15-.34.22-.53.22zm-2.19-4l2.19 2.19L17.44 12l-2.19-2.19L13.06 12zm-6.5 0l2.19 2.19L10.94 12 8.75 9.81 6.56 12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
})));